export enum UserRole {
    ADMIN = 'admin',
    MENTOR = 'mentor',
    MENTEE = 'mentee'
}
